import React, { useState } from 'react';
import { useRecoilValue } from 'recoil';
import { configurationComplete } from '@state';
import { useMutation } from 'react-query';
import axios from 'axios';

const SaveToAccount = ({ customer, product }) => {
  const mutation = useMutation((newConfig) => {
    return axios.post(`${process.env.PROXY_BASE_PATH}/api/user_configs`, newConfig);
  });
  const { isComplete, data } = useRecoilValue(configurationComplete);

  if (!Boolean(isComplete)) {
    return null;
  }

  const saveConfig = () => {
    // console.log({ ...data, product: product.handle, email: customer });
    mutation.mutateAsync({ ...data, product: product.handle, email: customer });
  };

  return (
    <div>
      <button type="button" className="button" data-style="dark text" onClick={() => saveConfig()}>
        {mutation.isLoading ? 'Saving...' : <>{mutation.isSuccess ? <span>Configuration Saved</span> : 'Save Configuration'}</>}
      </button>
    </div>
  );
};

export default SaveToAccount;
